/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line-added):not(.btn)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fas, .far, .fal, .fab");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line-added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
		GENERAL - external arrows to content links
		========================================================================== */

const externalLinksInit = function () {
  const externalLinks = document.querySelectorAll(".contentarea a.line-added, .person__heading a, .company__heading a");
  externalLinks.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    if (el.querySelector("img") < 1) {
      // If external link
      if (el.href.indexOf(php_variables.site_url) === -1) {
        el.classList.add("external-link");
      }
    }
  });
  //return true;
}; // externalLinksInit();
externalLinksInit();

/*  ==========================================================================
    GENERAL - sharinglinks
    ========================================================================== */

const sharingLinksInit = function () {
  const links = document.querySelector(".shareiconslist");

  if (!links) {
    return;
  }

  links.addEventListener("click", function (e) {
    e.preventDefault();
    const clicked = e.target.closest(".sharelink--popup");

    if (!clicked) {
      return;
    }

    const shareURL = clicked.getAttribute("href");
    window.open(shareURL, "share-dialog", "width=550,height=436");
  });
}; // sharingLinksInit();
sharingLinksInit();

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

const accordionQuestions = document.querySelectorAll(".accordion__question");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function () {
      item.closest(".accordion__item").classList.toggle("accordion__item--open");
    })
  );
}; // accordionInit();
accordionInit(accordionQuestions);

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
  GENERAL - Share Icons
========================================================================== */
const socialLinksInit = function () {
  const socialLinks = document.querySelectorAll(".sociallink");

  if (!socialLinks) {
    return;
  }

  socialLinks.forEach(socialLink =>
    socialLink.addEventListener("click", function (e) {
      e.preventDefault();
      const shareURL = this.getAttribute("href");
      var w = 550;
      var h = 550;
      var left = Number(screen.width / 2 - w / 2);
      var tops = Number(screen.height / 2 - h / 2);
      window.open(
        shareURL,
        "share-dialog",
        "resizable=no, width=" + w + ", height=" + h + ", top=" + tops + ", left=" + left + ""
      );
    })
  );
}; // socialLinksInit();
socialLinksInit();

/*  ==========================================================================
    GENERAL - Fancybox
  ========================================================================== */
const fancyboxInit = function () {
  const fancyboxOptions = {
    Hash: false, // Disabling Hash-based navigation, as it doesn't work on page reload
    Thumbs: false, // Disable thumbnails
    on: {
      done: (fancybox, slide) => {
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        const effects = document.querySelectorAll(".effect");
        effectsInit(effects);

        const fancyboxClose = document.getElementById("fancybox__close");
        fancyboxClose.addEventListener("click", function () {
          Fancybox.close();
        });
      }
    }
  };

  Fancybox.bind("[data-fancybox]", fancyboxOptions);

  Fancybox.bind(document.getElementById("ajax__tiles"), "[data-fancybox]", {
    mainClass: "fancybox__container--ajax",
    on: {
      done: (fancybox, slide) => {
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        const effects = document.querySelectorAll(".effect");
        effectsInit(effects);

        linksInit();
        externalLinksInit();

        const fancyboxClose = document.getElementById("fancybox__close");
        fancyboxClose.addEventListener("click", function () {
          Fancybox.close();
        });
      }
    }
  });

  const quoteCompanies = document.querySelectorAll(".module--quote");

  quoteCompanies.forEach(quoteCompany =>
    quoteCompany.addEventListener("click", function (e) {
      Fancybox.bind(quoteCompany, "[data-fancybox]", {
        mainClass: "fancybox__container--ajax",
        on: {
          done: (fancybox, slide) => {
            // Re-init lazy load
            lazyLoadInstance.update(); // reinit lazy load after clones
            // Re-init effects
            const effects = document.querySelectorAll(".effect");
            effectsInit(effects);

            linksInit();
            externalLinksInit();

            const fancyboxClose = document.getElementById("fancybox__close");
            fancyboxClose.addEventListener("click", function () {
              Fancybox.close();
            });
          }
        }
      });
    })
  );
}; // fancyboxInit();

fancyboxInit();

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

const loadmoreBtn = document.querySelector(".paging__loadmore");
const loadmoreContainer = document.querySelector(".loadmore-container");

const loadmoreLoadPostsMultiplePages = function (pages) {
  if (pages && pages > 1) {
    //Stopping default scroll back to previous position
    history.scrollRestoration = "manual";

    const currentPage = new URL(window.location);

    //Creating an array on page numbers to map it
    var list = [];
    for (var i = 1; i < pages; i++) {
      list.push(i);
    }

    // Initialising the array of posts pages
    var postsHTML = [];

    const button = loadmoreBtn;
    const buttonText = button.textContent; // store current button text
    button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts

    // Array of ajax calls
    var allAJAX = list.map(function (page) {
      const data = {
        action: "loadmore",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function
        page: page
      };
      //Updating the url to mtch the page number
      currentPage.searchParams.set("pagenum", page);
      return $.ajax({
        url: php_variables.ajax_url, // AJAX handler
        data: data,
        type: "POST",
        success: function (data) {
          postsHTML[page] = data;
        }
      });
    });

    // Waiting for all the ajax calls to be finished before proceeding
    Promise.all(allAJAX).then(function () {
      // Update current page variable
      php_variables.current_page = pages;

      button.textContent = buttonText; // set back to previous button text

      // Adding the new tiles to the dom
      list.map(page => {
        if (postsHTML[page]) {
          loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + postsHTML[page];
        }
      });

      // Updating the href for the loadmore button
      const nextPage = new URL(window.location);
      nextPage.searchParams.set("pagenum", parseInt(pages) + 1);
      button.href = nextPage;

      // if last page, remove the button..
      if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
        button.style.display = "none";
      }

      // Re-init lazy load
      lazyLoadInstance.update(); // reinit lazy load after clones
      // Re-init effects
      const effects = document.querySelectorAll(".effect");
      effectsInit(effects);

      // Scrolling the page to the last known position
      if (localStorage.getItem("scrollPosition")) {
        window.scroll({
          top: parseInt(localStorage.getItem("scrollPosition"), 10),
          behavior: "instant"
        });
      }
    });
  }
};

const loadmoreLoadPosts = function (e) {
  e.preventDefault(); // Preventing the a tag from redirecting to the page

  const button = this;
  const data = {
    action: "loadmore",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function
    page: php_variables.current_page
  };
  let buttonText; // create variable to store button text

  // This AJAX triggers a PHP hook within functions-ajax.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
    },
    success: function (data) {
      if (data) {
        button.textContent = buttonText; // set back to previous button text
        loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts

        php_variables.current_page++;

        // Only push state to set the last page number or if there is more pages to load
        const currentPage = new URL(window.location);

        if (parseInt(php_variables.current_page) <= parseInt(php_variables.max_page)) {
          currentPage.searchParams.set("pagenum", php_variables.current_page);
          history.pushState({}, "", currentPage);
        }

        //Updating the loadmore link
        const nextPage = new URL(window.location);
        nextPage.searchParams.set("pagenum", parseInt(php_variables.current_page) + 1);

        button.href = nextPage;

        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.style.display = "none";
        }
        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        const effects = document.querySelectorAll(".effect");
        effectsInit(effects);
      } else {
        button.style.display = "none"; // if no data, remove the button as well
      }
    }
  });
}; // loadmoreLoadPosts();

const loadmoreInit = function () {
  if (!loadmoreBtn) {
    return;
  }
  /** When adding fitering you will need to move this part into the filtering call */
  // Checking if the page paramenter is set
  const currentPage = new URL(window.location);
  let currentPageNum = currentPage.searchParams.get("pagenum");

  //If there is more than one page to load
  if (currentPageNum && currentPageNum > 1) {
    currentPageNum = currentPageNum > php_variables.max_page ? php_variables.max_page : currentPageNum;
    loadmoreLoadPostsMultiplePages(currentPageNum);
  }
  /** -end- */

  // Saving the scroll position before unload
  window.addEventListener("unload", function (e) {
    var scrollPosition = window.pageYOffset;
    localStorage.setItem("scrollPosition", scrollPosition);
  });

  loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
}; // loadmoreInit();

loadmoreInit();

/*  ==========================================================================
    Scroll effects
    ========================================================================== */

const effects = document.querySelectorAll(".effect");

const effectsInit = function (effects) {
  if (!effects) {
    return;
  }

  effects.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
        } else {
          val.classList.remove("effect--ready");
        }
      },
      offset: "95%"
    });
  });
}; // effectsInit();
effectsInit(effects);

/*  ==========================================================================
    Pageheader Lottie JSON
    ========================================================================== */

const lottieJsons = document.querySelectorAll(".pageheader__lottie__json");

const lottieJsonInit = function (lottieJsons) {
  if (!lottieJsons) {
    return;
  }
  lottieJsons.forEach(function (lottieJson) {
    const LOTTIE_PATH = lottieJson.dataset.json ? lottieJson.dataset.json : false;

    lottie.loadAnimation({
      container: lottieJson,
      path: LOTTIE_PATH,
      autoplay: true,
      loop: true,
      renderer: "svg",
      rendererSettings: {
        viewBoxOnly: true
      }
    });
  });
};
lottieJsonInit(lottieJsons);

/*  ==========================================================================
    Text animations
    ========================================================================== */

// Text Reveal (slide up)
const textReveal = document.querySelectorAll(".text-reveal");

const textRevealInit = function (textReveal) {
  if (!textReveal) {
    return;
  }

  textReveal.forEach(function (text) {
    // Run lettering js
    let lettering = new Lettering(".text-reveal");
    lettering.words();

    let letteringSpan = new Lettering(".text-reveal span");
    letteringSpan.letters();

    const body = document.querySelector("body");
    const spans = Array.from(body.querySelectorAll(".text-reveal span"));

    spans.forEach(span => {
      if (span.innerHTML === "") {
        span.remove();
      }
    });

    const textWaypoints = new Waypoint({
      element: text,
      handler: function (direction) {
        if (direction === "down") {
          text.classList.add("text-reveal--ready");
        } else {
          text.classList.remove("text-reveal--ready");
        }
      },
      offset: "90%"
    });
  });
}; // textRevealInit();
textRevealInit(textReveal);

/*  ==========================================================================
    Body Shadow effect
    ========================================================================== */
const content = document.querySelector(".main");

const scrollShadow = function (content) {
  if (!content) {
    return;
  }
  const body = document.querySelector("body");
  const siteHeader = document.querySelector(".siteheader");

  body.style.setProperty("--pseudo-opacity", 0);

  document.addEventListener("scroll", function () {
    const maxOpacity = 0.25; // Maximum opacity
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const documentHeight = document.documentElement.scrollHeight;
    const windowHeight = window.innerHeight;
    const scrollHeight = documentHeight - windowHeight;
    const scrollProgress = scrollTop / scrollHeight;

    // Calculate opacity based on scroll position
    let opacity = (scrollTop / siteHeader.offsetHeight) * maxOpacity;

    if (scrollProgress <= maxOpacity) {
      // Increase opacity from 0 to maxOpacity in the first half of scrolling
      opacity = (scrollTop / siteHeader.offsetHeight) * maxOpacity;
      if ((scrollTop / siteHeader.offsetHeight) * maxOpacity > maxOpacity) {
        opacity = maxOpacity;
      }
    }

    body.style.setProperty("--pseudo-opacity", opacity);
  });
};
scrollShadow(content);

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel");

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoHeight && elem.dataset.autoHeight === "disable" ? false : true;

    $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      items: 1,
      navText: ["<i class='far fa-arrow-left'></i>", "<i class='far fa-arrow-right'></i>"],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight,
      onInitialized: function () {
        lazyLoadInstance.update();
        Waypoint.refreshAll();
      }
    });

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
    Marquee - Infinite Scroll
    ========================================================================== */

const default_animation_speed = 1.5;

const elClass = "marquee";
const innerClass = "marquee__wrap";

const marqueeElements = document.querySelectorAll(".marquee");

const marquee__reset = function (el) {
  const wrapElements = el.querySelectorAll("." + innerClass);

  const viewportWidth = window.innerWidth;
  const minWidth = (viewportWidth * 1) / 2;

  // If the width of the wrap is less than the minimum width we need to duplicate existing tiles
  if (wrapElements[0].offsetWidth < minWidth) {
    // Getting the orginal items
    const originalNumItems = el.dataset.count ? el.dataset.count : 1;

    let orginalTiles = "";

    const tiles = wrapElements[0].querySelectorAll(".marquee__tile");

    for (let index = 0; index < originalNumItems; index++) {
      orginalTiles += '<div class="marquee__tile">' + tiles[index].innerHTML + "</div>";
    }

    //Calculating how many times do we need to repeat the original tiles based of the width of the tile
    const numTiles = tiles.length;
    const textWidth = tiles[0].offsetWidth * numTiles;
    const timesToRepeat = Math.ceil((minWidth - wrapElements[0].offsetWidth) / textWidth);

    //Adding the extra tiles to the three wraps
    for (let index = 0; index < timesToRepeat; index++) {
      wrapElements[0].innerHTML += orginalTiles;
      wrapElements[1].innerHTML += orginalTiles;
      wrapElements[2].innerHTML += orginalTiles;
    }
  }
};

const marquee__resize = function (el) {
  // Check if the marquee is large enought for the space
  // marquee__reset(el);

  // Check if element has custom speed or default
  let animation_speed = default_animation_speed;
  if (el.dataset.speed) {
    animation_speed = el.dataset.speed;
  } else {
    animation_speed = default_animation_speed;
  }

  const wrapElements = el.querySelectorAll("." + innerClass);

  // Calculate the animation time and delay for each wrap
  let linelength = wrapElements[0].offsetWidth;
  let distance = linelength;
  let speed = animation_speed * 0.01;
  let duration = distance / speed;

  let delay = 0 - duration / 3;

  wrapElements.forEach(function (wrap, index) {
    let count = index + 1;
    wrap.style.animationDuration = duration + "ms";
    wrap.style.animationDelay = delay * count + "ms";
  });
};

const marquee__init = function () {
  if (!marqueeElements) {
    return;
  }

  window.addEventListener("resize", function () {
    marqueeElements.forEach(function (el) {
      // Setup animation times
      marquee__resize(el);
    });
  });

  marqueeElements.forEach(function (el) {
    // Wrapping the tiles
    el.innerHTML = "<div class='" + innerClass + "'>" + el.innerHTML + "</div>";

    // Duplicating the wrap element
    const repeatingTextClone = el.querySelector(".marquee__wrap").cloneNode(true),
      repeatingTextClone2 = el.querySelector(".marquee__wrap").cloneNode(true);

    repeatingTextClone.ariaHidden = "true";
    repeatingTextClone2.ariaHidden = "true";

    el.appendChild(repeatingTextClone);
    el.appendChild(repeatingTextClone2);

    // Force all lazy images within carousels to load immediately, otherwise they wont load
    const marquee_lazyimgs = document.querySelectorAll(".marquee .lazy");
    marquee_lazyimgs.forEach(img => {
      LazyLoad.load(img);
    });

    // Setup animation times
    marquee__resize(el);

    // Once everything is set up, add "loaded" class
    el.classList.add(elClass + "--loaded");
  });
};

// Defer loading this code until after page load
window.addEventListener("load", marquee__init);

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

const mobnav = document.querySelector(".mobnav");
const siteHeaderBd = document.querySelector(".siteheader__bd");
const mobnavToggle = document.querySelectorAll(".mobnav-toggle");
const mobnavOpenclass = "mobnavopen";

const mobnavInit = function () {
  if (!mobnav) {
    return;
  }

  // Open mobnav on click the toggle
  mobnavToggle.forEach(function (mobnavToggl) {
    mobnavToggl.addEventListener("click", function (e) {
      e.preventDefault();

      let mobnavHeight = 0;
      if (!body.classList.contains(mobnavOpenclass)) {
        // IT'S NOT OPEN...
        body.classList.add(mobnavOpenclass);
      } else {
        // IT'S OPEN...
        body.classList.remove(mobnavOpenclass);
      }
    });
  });
}; // mobnavInit()
mobnavInit();

/*  ==========================================================================
      NAVIGATION - mobnav dropdowns
      ========================================================================== */

const mobnavLinks = document.querySelectorAll(".mobnav .sitenav__item--hasdropdown .sitenav__item__dropdownarrow");

const mobnavlinksInit = function () {
  if (!mobnavLinks) {
    return;
  }

  mobnavLinks.forEach(function (mobnavLink) {
    mobnavLink.addEventListener("click", function (e) {
      e.preventDefault();
      const mobnavTargetSection = e.target.closest(".sitenav__item");
      mobnavTargetSection.classList.toggle("sitenav__item--open");
    });
  });
}; // mobnavlinksInit();
mobnavlinksInit();

/*  ==========================================================================
		Check Scroll
		========================================================================== */
let oldScrollY = 0;

function checkScroll() {
  const siteheader = document.querySelector(".siteheader");

  if (!siteheader) {
    return;
  }

  if ($(window).scrollTop() > 0) {
    siteheader.classList.add("siteheader--scrolled");
  } else {
    siteheader.classList.remove("siteheader--scrolled");
  }
}

$(window).scroll(function () {
  checkScroll();
});

checkScroll();

/*  ==========================================================================
			Company Filtering
			========================================================================== */

const companyFiltering = document.querySelectorAll(".companies");

const companyFilteringInit = function (companyFiltering) {
  if (companyFiltering.length <= 0) {
    return;
  }

  const companies = document.querySelector(".companies");
  var mixer = mixitup(companies, {
    multifilter: {
      enable: true
    },
    animation: {
      effects: "fade"
    }
  });
};
// companyFilteringInit();
companyFilteringInit(companyFiltering);

/*  ==========================================================================
    PITCH - Pitch Progress
  ========================================================================== */

const pitchProgress = document.querySelector(".pitch__progress .bd");

const pitchProgressInit = function (pitchProgress) {
  if (!pitchProgress) {
    return;
  }

  const progressBar = document.querySelector(".gf_progressbar");

  pitchProgress.appendChild(progressBar);
}; // pitchProgressInit();
pitchProgressInit(pitchProgress);
